import Cookies from "js-cookie";
import { useState, Fragment, useEffect, memo } from "react";
import Link from "next/link";
import { toast } from "react-toastify";
import userStore from "../../store/userStore";
import votesStore from "../../store/votesStore";
import ModalExtraSmall from "../ModalExtraSmall";
import axios from "axios";
import { useRouter } from "next/navigation";
import { bloquerMembre } from "../../tools/bloquerMembre";
import { pluriel } from "../../tools/helper";
import { ImArrowUp, ImArrowDown } from "react-icons/im";
import {
  Md18UpRating,
  MdBlock,
  MdBookmark,
  MdClose,
  MdDelete,
  MdEdit,
  MdLock,
  MdLockOpen,
  MdOutlineChatBubbleOutline,
  MdOutlineMoreHoriz,
  MdOutlineMoreVert,
  MdReport,
  MdShare,
  MdStar,
  MdStarBorder,
} from "react-icons/md";

function ItemFooter(props) {
  let [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const [showModalOptions, setShowModalOptions] = useState(false);

  const userIsConnected = userStore.getState().userIsConnected;
  const userPermalink = userStore.getState().userPermalink;
  const votes = votesStore((state) => state.votes);
  const addVote = votesStore((state) => state.addVote);
  const [showPartager, setShowPartager] = useState(false);

  const [points, setPoints] = useState(props.item.points);
  var valeurVotePositifFromApi = false;
  var valeurVoteNegatifFromApi = false;

  if (
    props.item.voted &&
    props.item.voted &&
    props.item.voted_type == "positif"
  )
    valeurVotePositifFromApi = true;

  if (
    props.item.voted &&
    props.item.voted &&
    props.item.voted_type == "negatif"
  )
    valeurVoteNegatifFromApi = true;

  const [valeurVotePositif, setValeurVotePositif] = useState(
    valeurVotePositifFromApi
  );
  const [valeurVoteNegatif, setValeurVoteNegatif] = useState(
    valeurVoteNegatifFromApi
  );

  useEffect(() => {
    setPoints(props.item.points);
    if (
      props.item.voted &&
      props.item.voted &&
      props.item.voted_type == "positif"
    ) {
      setValeurVotePositif(true);
      setValeurVoteNegatif(false);
    }

    if (
      props.item.voted &&
      props.item.voted &&
      props.item.voted_type == "negatif"
    ) {
      setValeurVoteNegatif(true);
      setValeurVotePositif(false);
    }
  }, [props.item]);

  // on surveille le store votes pour mettre à jour les boutons sur la boucle au cas où un vote est fait dans la modal
  useEffect(() => {
    if (votes[props.item.permalink]) {
      if (votes[props.item.permalink].valeur == "positif") {
        setValeurVotePositif(true);
        setValeurVoteNegatif(false);
        setPoints(votes[props.item.permalink].newpoints);
      } else if (votes[props.item.permalink].valeur == "negatif") {
        setValeurVotePositif(false);
        setValeurVoteNegatif(true);
        setPoints(votes[props.item.permalink].newpoints);
      } else {
        setValeurVotePositif(false);
        setValeurVoteNegatif(false);
        setPoints(votes[props.item.permalink].newpoints);
      }
    } else {
      setValeurVotePositif(valeurVotePositifFromApi);
      setValeurVoteNegatif(valeurVoteNegatifFromApi);
    }
  }, [votes, props.item.permalink]);

  const [voteInProgress, setVoteInProgress] = useState(false);
  const voter = async (valeur, permalink) => {
    if (!props.userTk) {
      // toast("Vous devez être membre pour voter.", { type: "error" });

      router.push("/m/connexion");

      return false;
    }

    setVoteInProgress(true);

    // on met l'effet tout de suite
    if (valeur == "positif" && valeurVotePositif == false) {
      setValeurVotePositif(true);
      setValeurVoteNegatif(false);
      // setPoints("..");
    } else if (valeur == "negatif" && valeurVoteNegatif == false) {
      setValeurVotePositif(false);
      setValeurVoteNegatif(true);
      // setPoints("..");
    } else {
      setValeurVotePositif(false);
      setValeurVoteNegatif(false);
      // setPoints("..");
    }

    var bodyFormData = new URLSearchParams();
    bodyFormData.append("valeur", valeur);
    bodyFormData.append("permalink", permalink);
    bodyFormData.append("token", props.userTk);

    await fetch(process.env.NEXT_PUBLIC_API_URL + "/api/boxs/voter", {
      method: "POST",
      body: bodyFormData,
      // headers: {
      //   "User-Agent": "Choualbox Next",
      // },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((result) => {
        if (result.status == 200) {
          setPoints(result.newpoints);
          if (result.type == "voted" && valeur == "positif") {
            setValeurVotePositif(true);
            setValeurVoteNegatif(false);
            addVote(permalink, "boxs", "positif", result.newpoints);
          } else if (result.type == "voted" && valeur == "negatif") {
            setValeurVoteNegatif(true);
            setValeurVotePositif(false);
            addVote(permalink, "boxs", "negatif", result.newpoints);
          } else {
            setValeurVotePositif(false);
            setValeurVoteNegatif(false);
            addVote(permalink, "boxs", null, result.newpoints);
          }
        } else {
          toast(result.message, { type: "error" });
        }
      })
      .catch((error) => {
        console.error(error);
      });

    setVoteInProgress(false);
  };

  // favoris
  const [saved, setSaved] = useState(props.item.saved);
  const [saveInProcess, setSaveInProcess] = useState(false);

  const favoris = async () => {
    if (!userIsConnected) {
      toast.error("Vous devez être membre pour ajouter un favoris.");
      return false;
    }

    // setSaved(!saved);
    setSaveInProcess(true);

    var bodyFormData = new URLSearchParams();
    bodyFormData.append("id_module", props.item.permalink);
    bodyFormData.append("token", props.userTk);
    bodyFormData.append("module", props.module);

    await fetch(
      process.env.NEXT_PUBLIC_API_URL + "/api/membres/ajouterfavoris",
      {
        method: "POST",
        body: bodyFormData,
        // headers: {
        //   "User-Agent": "Choualbox Next",
        // },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((result) => {
        if (result.status == 200) {
          setSaved(result.saved);
          toast.success(result.message);
        } else {
          toast.error(result.message);
        }

        setSaveInProcess(false);
      });

    setSaveInProcess(false);
  };

  function marquerNSFW() {
    if (confirm("Marquer cette box NSFW?") == true) {
      var bodyFormData = new URLSearchParams();
      bodyFormData.append("token", props.userTk);
      bodyFormData.append("permalink", props.item.permalink);

      const options = {
        // headers: {
        //   "User-Agent": "Choualbox Next",
        // },
      };
      axios
        .post(
          process.env.NEXT_PUBLIC_API_URL + "/api/boxs/ajouternsfw",
          bodyFormData,
          options
        )
        .then((response) => {
          if (response.data.status === 200) {
            toast(response.data.message, { type: "success" });
            router.reload(window.location.pathname);
          } else {
            toast(response.data.message, { type: "error" });
          }
        });
    }
  }

  function supprimerBox() {
    if (confirm("Supprimer cette box?") == true) {
      var bodyFormData = new URLSearchParams();
      bodyFormData.append("token", props.userTk);
      bodyFormData.append("permalink", props.item.permalink);

      const options = {
        // headers: {
        //   "User-Agent": "Choualbox Next",
        // },
      };
      axios
        .post(
          process.env.NEXT_PUBLIC_API_URL + "/api/boxs/desactiver",
          bodyFormData,
          options
        )
        .then((response) => {
          if (response.data.status === 200) {
            toast(response.data.message, { type: "success" });

            router.refresh();
          } else {
            toast(response.data.message, { type: "error" });
          }
        });
    }
  }

  function fermerCommentaires() {
    if (confirm("Fermer les commentaires ?") == true) {
      var bodyFormData = new URLSearchParams();
      bodyFormData.append("token", props.userTk);
      bodyFormData.append("permalink", props.item.permalink);

      const options = {
        // headers: {
        //   "User-Agent": "Choualbox Next",
        // },
      };
      axios
        .post(
          process.env.NEXT_PUBLIC_API_URL + "/api/boxs/fermercommentaires",
          bodyFormData,
          options
        )
        .then((response) => {
          if (response.data.status === 200) {
            toast(response.data.message, { type: "success" });

            router.refresh();
          } else {
            toast(response.data.message, { type: "error" });
          }
        });
    }
  }

  // share / partager
  const [shareIsSupported, setShareIsSupported] = useState(false);

  useEffect(() => {
    if (navigator.share) {
      setShareIsSupported(true);
    }
  }, []);

  const handleShare = async () => {
    try {
      await navigator.share({
        text: props.item.titre,
        url: process.env.NEXT_PUBLIC_URL_CANONICAL + "/" + props.item.permalink,
        title: "Partager",
      });
    } catch (err) {
      console.log("Sharing canceled:", err);
    }
  };

  return (
    <>
      <div
        className="flex relative justify-between w-full mt-1 pb-1 text-base-content"
        // onClick={(e) => {
        //   e.stopPropagation();
        // }}
      >
        <div className="join">
          <button
            className={`btn btn-base btn-sm btn-ghost rounded-none join-item no-animation  ${
              valeurVotePositif ? "text-success" : "opacity-100"
            }
          `}
            aria-label="Vote positif"
            onClick={(e) => {
              e.stopPropagation();
              voter("positif", props.item.permalink);
            }}
          >
            {valeurVotePositif ? (
              <ImArrowUp className="w-4 h-4" />
            ) : (
              <ImArrowUp className="w-4 h-4" />
            )}
            <div className={voteInProgress ? "animate-pulse" : ""}>
              {points}
            </div>
          </button>
          <button
            className={`btn btn-base btn-sm btn-ghost rounded-none join-item no-animation  ${
              valeurVoteNegatif ? "text-error" : "opacity-100"
            }
          `}
            onClick={(e) => {
              e.stopPropagation();
              voter("negatif", props.item.permalink);
            }}
            aria-label="Vote négatif"
          >
            {valeurVoteNegatif ? (
              <ImArrowDown className="w-4 h-4" />
            ) : (
              <ImArrowDown className="w-4 h-4" />
            )}
          </button>
        </div>
        <div className="flex">
          <button
            className="btn btn-base btn-sm btn-ghost rounded-none text-xs normal-case font-normal no-animation"
            aria-label="Commentaires"
          >
            <MdOutlineChatBubbleOutline className="w-6 h-6" />
            {props.item.commentaires_count}
            <div className="hidden sm:inline-block">
              commentaire{props.item.commentaires_count > 1 ? "s" : ""}
            </div>
            <div className="inline-block sm:hidden">
              com{props.item.commentaires_count > 1 ? "s" : ""}
            </div>
          </button>
        </div>
        <div className="hidden sm:block sm:grow"></div>
        {/* <button
          aria-label="Ajouter / Retirer des favoris"
          onClick={(e) => {
            favoris();
            e.stopPropagation();
          }}
          className={`btn btn-base btn-sm btn-ghost rounded-none ${
            saved == 1 ? "text-accent" : "opacity-100"
          }
          
          `}
        >
          {saved ? (
            <MdStar className={`w-6 h-6 ${saveInProcess && "animate-spin"}`} />
          ) : (
            <MdStarBorder
              className={`w-6 h-6 ${saveInProcess && "animate-spin"}`}
            />
          )}
        </button> */}

        <button
          onClick={(e) => {
            setShowModalOptions(true);
            e.stopPropagation();
          }}
          className="btn btn-base btn-sm btn-ghost rounded-none"
          aria-label="Options"
        >
          <MdOutlineMoreHoriz className="w-6 h-6" />
        </button>
      </div>
      {showModalOptions && (
        <ModalExtraSmall
          isOpen={showModalOptions}
          handleChange={() => {
            // router.push(router.pathname, undefined, {
            //   shallow: true,
            //   scroll: false,
            // });
            // var uri = window.location.toString();
            // var clean_uri = uri.substring(0, uri.indexOf("#"));
            // router.replace(clean_uri);
            setShowModalOptions(false);
          }}
        >
          {/* <div className="flex flex-row text-base-content">
            <ChartBarIcon className="w-4 h-4 mr-2" />
            <div className="grow">
              <div className="w-full bg-error rounded-full h-2.5">
                <div
                  className="bg-success h-2.5 rounded-full"
                  style={{ width: props.item.pourcentage + "%" }}
                ></div>
              </div>
              <div className="text-base-content opacity-80 text-xxs mt-1">
                {props.item.nbpositif} positif{pluriel(props.item.nbpositif)} /{" "}
                {props.item.nbnegatif} négatif{pluriel(props.item.nbnegatif)}
              </div>
            </div>
          </div>
          <div className="border-t border-base-content/10 my-2"></div> */}
          {props.item.can_edit && props.item.can_edit == 1 ? (
            <button
              className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
              onClick={(e) => {
                router.push("/box/modifier/" + props.item.permalink);
                setShowModalOptions(false);
                e.stopPropagation();
              }}
            >
              <MdEdit className="w-4 h-4 mr-2" /> Modifier
            </button>
          ) : null}
          {props.item.can_delete === 1 || props.item.can_moderate === 1 ? (
            <button
              className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
              onClick={(e) => {
                supprimerBox();
                e.stopPropagation();
              }}
            >
              <MdDelete className="w-4 h-4 mr-2" /> Supprimer
            </button>
          ) : null}
          {props.item.can_moderate === 1 && (
            <button
              className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
              onClick={(e) => {
                fermerCommentaires();
                e.stopPropagation();
              }}
            >
              {props.item.closed == 0 ? (
                <>
                  <MdLock className="w-4 h-4 mr-2" /> Fermer les commentaires
                </>
              ) : (
                <>
                  <MdLockOpen className="w-4 h-4 mr-2" /> Ouvrir les
                  commentaires
                </>
              )}
            </button>
          )}
          {props.item.can_moderate === 1 && props.item.nsfw == 0 ? (
            <button
              className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
              onClick={(e) => {
                marquerNSFW();
                e.stopPropagation();
              }}
            >
              <Md18UpRating className="w-4 h-4 mr-2" /> Marquer NSFW
            </button>
          ) : null}
          {props.userTk && (
            <button
              onClick={(e) => {
                favoris();
              }}
              className={`flex w-full items-center leading-12 text-sm hover:text-secondary cursor-pointer ${
                saved == 1 ? "text-accent" : "text-base-content"
              }`}
            >
              <MdBookmark className="w-4 h-4 mr-2" />
              {saved == 1 ? "Retirer des favoris" : "Ajouter aux favoris"}
            </button>
          )}
          <button
            onClick={(e) =>
              shareIsSupported
                ? handleShare()
                : alert(
                    "La fonction partager n'est pas disponible sur ce navigateur."
                  )
            }
            className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
          >
            <MdShare className="w-4 h-4 mr-2" /> Partager cette box
          </button>
          <button
            className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
            onClick={(e) => {
              router.push(
                "/signaler?module=box&id_module=" + props.item.permalink
              );
              e.stopPropagation();
            }}
          >
            <MdReport className="w-4 h-4 mr-2" /> Signaler cette box
          </button>
          {userIsConnected && userPermalink != props.item.membre_permalink ? (
            <>
              <div className="border-t border-base-content/10 my-2"></div>
              <button
                className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
                onClick={(e) => {
                  if (
                    confirm(
                      "Bloquer " +
                        props.item.membre_pseudo +
                        " ? " +
                        props.item.membre_pseudo +
                        " ne pourra plus voir votre profil, vos boxs, vos commentaires ou vous contacter et vice versa."
                    ) == true
                  ) {
                    bloquerMembre(props.item.membre_pseudo, props.userTk);
                  }

                  e.stopPropagation();
                }}
              >
                <MdBlock className="w-4 h-4 mr-2" /> Bloquer{" "}
                {props.item.membre_pseudo}
              </button>
              <button
                className="flex w-full items-center text-base-content leading-12 text-sm hover:text-secondary cursor-pointer"
                onClick={(e) => {
                  router.push(
                    "/signaler?module=membre&id_module=" +
                      props.item.membre_permalink
                  );
                  e.stopPropagation();
                }}
              >
                <MdReport className="w-4 h-4 mr-2" /> Signaler{" "}
                {props.item.membre_pseudo}
              </button>
            </>
          ) : null}
        </ModalExtraSmall>
      )}
    </>
  );
}

export default memo(ItemFooter);
